module.exports = __webpack_public_path__ + "assets/img/serve4.d2d22082.png";